import { render } from "./SkillTable.vue?vue&type=template&id=0fb0a232"
import script from "./SkillTable.vue?vue&type=script&lang=ts"
export * from "./SkillTable.vue?vue&type=script&lang=ts"

import "./SkillTable.vue?vue&type=style&index=0&id=0fb0a232&lang=scss"
script.render = render

export default script